import { render, staticRenderFns } from "./AccessHistoryTable.vue?vue&type=template&id=40b3ed50&"
import script from "./AccessHistoryTable.vue?vue&type=script&lang=js&"
export * from "./AccessHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./AccessHistoryTable.vue?vue&type=style&index=0&id=40b3ed50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports